import React from "react";

import { getPurchaseTrip } from "@app/helpers/purchase/get-purchase-trip";
import { isRoundtrip } from "@app/helpers/udm/is-roundtrip";
import { TripCancelStatus } from "@app/modules/account";

import { useCancelTripContext } from "./cancel-trip-context";
import {
  CancelFailedAlert,
  RoundtripAlert
} from "./cancellation-confirmation/cancel-alerts";

export const CancelTripAlerts: React.FC = () => {
  const { purchase } = useCancelTripContext();
  const trip = getPurchaseTrip(purchase);

  const is_failed = purchase.cancellation
    ? purchase.cancellation.state === TripCancelStatus.failed
    : false;

  return (
    <>
      {!!is_failed && <CancelFailedAlert />}
      {!!isRoundtrip(trip) && <RoundtripAlert />}
    </>
  );
};
